import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SemAutorizacaoGuardService implements CanActivate {
  private usuarioLogado = false;
  constructor(
    private authentication: AuthenticationService,
    private router: Router
  ) {
    this.authentication.authNavStatus$.subscribe({
      next: (status) => {
        this.usuarioLogado = status;
      }
    });
  }

  canActivate(): boolean {
    if (!this.usuarioLogado) {
      this.router.navigate(['/login']);
      return false;
    }
    const autorizacoes = this.authentication.obterToken()['autorizacoes'];
    if (autorizacoes.visualizarDashboard) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
